import React from "react";
import { Link } from "react-router-dom";
import { ChevronRight, Check } from "lucide-react";
import PageHero, { usePageMeta } from "@/components/marketing/PageHero";
import Reveal from "@/components/marketing/Reveal";
import { Button } from "@/components/ui/button";
import { getServices } from "@/data/site";
import { useI18n } from "@/context/I18nContext";

export default function Servizi() {
  const { lang } = useI18n();
  const L = (it, en, de) => (lang === "en" ? en : lang === "de" ? (de ?? it) : it);
  usePageMeta(L("Servizi", "Services", "Dienstleistungen"), L("I servizi di assistenza al recupero dell'accesso ai wallet crypto di Recovers Crypto.", "Recovers Crypto wallet access recovery services.", "Dienstleistungen von Recovers Crypto zur Wiederherstellung des Wallet-Zugriffs."));
  const services = getServices(lang);
  return (
    <div>
      <PageHero eyebrow={L("Servizi", "Services", "Dienstleistungen")} title={L("Assistenza professionale al recupero", "Professional recovery assistance", "Professionelle Unterstützung bei der Wiederherstellung")}
        subtitle={L("Interventi specializzati per diverse tipologie di problema, sempre in modalità non-custodial e con verifica della titolarità.", "Specialized interventions for various types of problems, always non-custodial and with ownership verification.", "Spezialisierte Maßnahmen für verschiedene Problemarten, stets non-custodial und mit Eigentumsprüfung.")} />
      <section className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 py-20">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
          {services.map((s, i) => (
            <Reveal key={s.slug} delay={i * 0.06}>
              <div className="h-full rounded-xl border border-white/10 bg-navy-paper p-7 hover:border-cyanx/30 transition-colors">
                <span className="inline-flex h-12 w-12 items-center justify-center rounded-lg bg-gold/10 text-gold border border-gold/20">
                  <s.icon className="h-6 w-6" />
                </span>
                <h3 className="mt-5 font-heading text-xl font-medium text-white">{s.title}</h3>
                <p className="mt-2.5 text-sm text-slate-400">{s.short}</p>
                <ul className="mt-4 space-y-1.5">
                  {s.cases.map((c) => (
                    <li key={c} className="flex items-center gap-2 text-xs text-slate-500"><Check className="h-3.5 w-3.5 text-cyanx" />{c}</li>
                  ))}
                </ul>
                <div className="mt-6 flex items-center gap-4">
                  <Link to={`/servizi/${s.slug}`} className="text-sm text-cyanx hover:text-white inline-flex items-center gap-1" data-testid={`service-link-${s.slug}`}>{L("Approfondisci", "Learn more", "Mehr erfahren")} <ChevronRight className="h-4 w-4" /></Link>
                  <Link to="/avvia-recupero" className="text-sm text-gold hover:text-gold-hover">{L("Richiedi una valutazione", "Request an assessment", "Bewertung anfragen")}</Link>
                </div>
              </div>
            </Reveal>
          ))}
        </div>
        <div className="mt-14 flex justify-center">
          <Button asChild size="lg" className="bg-gold text-navy hover:bg-gold-hover"><Link to="/avvia-recupero">{L("Avvia un recupero", "Start a recovery", "Wiederherstellung starten")}</Link></Button>
        </div>
      </section>
    </div>
  );
}
